import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useContext, useEffect, useState } from 'react'
import Post from './Post'
import { TokenContext } from './Contexts/TokenContext'
import { NavLink } from 'react-router-dom'
import ButtonAuth from './ButtonAuth'
import classNames from 'classnames'
import axios from 'axios'

export default function ModalComments({isOpen,setIsOpen,profileImage}) {
const {isToken} = useContext(TokenContext)
    // const [title,setTitle] = useState('')
    // const [contentPost,setContnetPost] = useState('')
    // const [authorUsername,setAuthorUsername] = useState('')
    // const [profileImage,setProfileImage] = useState('')
    // const [imagePost,setImagePost] = useState('')
    // const [createTime,setCreateTime] = useState('')
    // const [commentsCount,setCommentsCount] = useState('')
    // const [comments,setComments] = useState([])
    
    
  function closeModal() {
    setIsOpen(false)
  }
  useEffect(() =>{
  //  console.log(postId);
  console.log(profileImage);
  },[<ModalComments />])
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25 " />
          </Transition.Child>
          
          <div className="fixed inset-0">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                
                <Dialog.Panel className={classNames("  lg:w-6/12 pb-6 transform rounded-2xl bg-white text-left align-middle shadow-xl transition-all z-50 block overflow-x-hidden ",{
                  "overflow-y-scroll h-[700px]":isToken,
                  "overflow-y-hidden ":!isToken
                })}>
                    <div className='text-right mt-6 mr-10 cursor-pointer flex justify-between w-full items-center px-8' onClick={closeModal}>
                      { isToken && <span className='font-bold text-xl'>Mohanned Post</span>}
                      { !isToken && <span className='font-bold text-xl mt-5'></span>}
                        <i className="fa-solid fa-xmark fa-xl text-[#7f7f7f]"></i>
                    </div>
                   {isToken ?
                   <Fragment>
                        <Post closeModal={true} classname="focus-within:shadow-[1px_1px_7px_3px_#A9DEF9]" commentClassname ="flex" profileImage={profileImage}/>
                      
                   </Fragment> :
                   <Fragment>
                    <div className='mx-5 mt-5 '>
                        <Dialog.Title
                          as="h3"
                          className="text-lg font-medium leading-6 text-gray-900 mb-3 "
                        >
                         Welcome to our website! We're thrilled you're here. To access all the amazing features and content we have to offer
                        </Dialog.Title>
                        <ButtonAuth  classBtnLogin=" bg-[#e6e6e6] md:hover:bg-[#d9d9d9] rounded-xl" classBtnRegister="bg-[#8ccaf1] md:hover:bg-[#a5d5f3] rounded-xl"  />
                        {/* <div className="mt-4 inline-block ml-5  ">
                          <button
                            type="button"
                            className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                            onClick={closeModal}
                          >
                            Got it, thanks!
                          </button>
                        </div> */}
                        </div>
                   </Fragment> } 
                                        
                  </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}